import { ReactNode } from "react";
import { Stepper } from "@/components/ui/stepper";
import { UserMenu } from "@/components/UserMenu";
import quentariLogo from "@/assets/quentari-logo.svg";

interface OnboardingLayoutProps {
  children: ReactNode;
  currentStep: number;
  totalSteps: number;
  stepNames?: string[];
  onStepClick?: (step: number) => void;
}

export const OnboardingLayout = ({
  children,
  currentStep,
  totalSteps,
  stepNames,
  onStepClick,
}: OnboardingLayoutProps) => {
  return (
    <div className="min-h-screen bg-muted/40">
      <header className="sticky top-0 z-50 w-full bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60 border-b border-border transition-all duration-300">
        <div className="container flex h-16 items-center justify-between max-w-7xl mx-auto px-4 md:px-6">
          <div className="flex items-center">
            <img 
              src={quentariLogo} 
              alt="Quentari" 
              className="h-8 w-auto transition-transform duration-300 hover:scale-105" 
            />
          </div>
          <UserMenu />
        </div>
      </header>

      <main className="container max-w-[920px] mx-auto px-6 md:px-8 pt-10 pb-24">
        {/* Stepper – visually reduced */}
        <div className="mb-10 opacity-70">
          <Stepper 
            currentStep={currentStep} 
            totalSteps={totalSteps} 
            stepNames={stepNames}
            onStepClick={onStepClick}
          />
        </div>

        {/* Content card with white background for contrast against muted page */}
        <div className="bg-card rounded-2xl border border-border p-6 md:p-10 shadow-sm">
          {children}
        </div>
      </main>
    </div>
  );
};
